import React from 'react'
import { Link } from 'react-router-dom'
import Image from '../components/Image'
import ImageCarousel from '../components/ImageCarousel'
import RelativeDate from '../components/RelativeDate'
import ContentContainer from '../components/ContentContainer'
import ContentLoader from '../components/ContentLoader'
import * as DataUtils from '../util/DataUtils'
import * as Utils from '../util/Utils'

export default class Post extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
    }
  }
  componentDidMount() {

  }
  componentDidUpdate(prevProps, prevState, snapshot) {

  }
  linkTo() {
    const content = this.props
    if (typeof(content)==='object'&&content!==null) {
      const type = content[DataUtils.TYPE]
      if (typeof(type)==='string'&&type.length>0) {
        const slug = content[DataUtils.SLUG]
        if (typeof(slug)==='string'&&slug.length>0) {
          return `/${type.toLowerCase()}/${slug}`
        }
        const id = content[DataUtils.ID]
        if (typeof(id)==='string'&&id.length>0) {
          return `/${type.toLowerCase()}/id/${id}`
        }
      }
    }
    return undefined
  }
  render() {
    const to = this.linkTo()
    return (
      <React.Fragment>
        {
          this.props.viewMode==='teaser'&&
          <div className="card">
            <Image {...this.props.images}
              imgClassName="card-img-top"
              maxWidth={312}
            />
            <div className="card-body">
              <h5 className="card-title">{this.props.title}</h5>
              <span><RelativeDate value={this.props._created} /></span>
              <Tags values={this.props.tags} className="mb-2" />
              <p
                className="card-text"
                dangerouslySetInnerHTML={Utils.fromMd(this.props.lead)}
              />
              {
                typeof(to)==='string'&&to.length>0&&
                <Link to={to}>Read more</Link>
              }
              {
                typeof(this.props.onClick)==='function'&&
                <button
                  className="btn btn-outline-primary"
                  onClick={this.props.onClick}
                >Read more</button>
              }
            </div>
          </div>
        }
        {
          (this.props.viewMode===undefined || this.props.viewMode==='full')&&
          <div className="container">
            <Nav
              prev={this.props.prev}
              next={this.props.next}
            />
            <div className="row mb-3">
              <div className="col">
                <div className="post">
                  <h1>{this.props.title}</h1>
                  <div>
                    <RelativeDate value={this.props._created} />
                  </div>
                  <Link to={`/${this.props[DataUtils.TYPE].toLowerCase()}/id/${this.props[DataUtils.ID]}`}>Permanent Link</Link>
                  <Tags values={this.props.tags} className="mb-3" />
                  <p
                    className="lead"
                    dangerouslySetInnerHTML={Utils.fromMd(this.props.lead)}
                  />
                  {
                    Array.isArray(this.props.images)&&
                    this.props.images.length>1&&
                    <div className="mb-3">
                      <ImageCarousel
                        images={this.props.images}
                        viewMode="full"
                      />
                    </div>
                  }
                  {
                    Array.isArray(this.props.images)&&
                    this.props.images.length===1&&
                    <Image
                      {...this.props.images}
                      viewMode="full"
                      className="mb-3"
                    />
                  }
                  <p
                    dangerouslySetInnerHTML={Utils.fromMd(this.props.body)}
                  />
                  {
                    Array.isArray(this.props.by)&&
                    this.props.by.length>0&&
                    <ContentLoader {...this.props.by[0]}
                      className="author"
                    />
                  }
                </div>
              </div>
            </div>
            <Nav
              prev={this.props.prev}
              next={this.props.next}
            />
            {
              false&&
              <div>
                {
                  typeof(this.props.prev)==='object'&&
                  this.props.prev!==null&&
                  <ContentLoader {...this.props.prev}
                    viewMode="teaser"
                    location={this.props.location}
                  />
                }
                {
                  typeof(this.props.next)==='object'&&
                  this.props.next!==null&&
                  <ContentLoader {...this.props.next}
                    viewMode="teaser"
                    location={this.props.location}
                  />
                }
              </div>
            }
          </div>
        }
      </React.Fragment>
    )
  }
}

function Tags(props) {
  if (
    Array.isArray(props.values)&&
    props.values.length>0
  ) {
    return (
      <div className={props.className}>
        {
          props.values.map((tag,index)=>(
            <ContentContainer
              key={index}
              {...tag}
              className="mr-1"
            />
          ))
        }
      </div>
    )
  }
  return null
}

function Nav(props) {
  if (typeof(props)==='object'&&props!==null) {
    return (
      <div className="row mb-3">
        {
          false&&
          <pre><code>{JSON.stringify(props.prev,null,2)}</code></pre>
        }
        {
          typeof(props.prev)==='object'&&
          props.prev!==null&&
          <div className="col">
            <Link
              to={`/${props.prev[DataUtils.TYPE].toLowerCase()}/${props.prev[DataUtils.SLUG]}`}
            >
              Prev: {props.prev.title}
            </Link>
          </div>
        }
        {
          typeof(props.next)==='object'&&
          props.next!==null&&
          <div className="col">
            <Link
              to={`/${props.next[DataUtils.TYPE].toLowerCase()}/${props.next[DataUtils.SLUG]}`}
              className="float-right"
            >
              Next: {props.next.title}
            </Link>
          </div>
        }
      </div>
    )
  }
  return null
}

/*
aspectRatio:1.782
ext:".jpg"
id:"15226512766455d6e8391"
name:"15226512766455d6e8391.jpg"
function Image(props) {
  let src = '...'
  if (typeof(props)==='object'&&props!==null) {
    let image = props
    if (typeof(image[0])==='object'&&image[0]!==null) {
      image = image[0]
    }
    const fileName = image.name
    if (typeof(fileName)==='string'&&fileName.length>0) {
      const dataPath = `../data/`
      const imagesPath = `${dataPath}/images/w312h170`
      src = `${imagesPath}/${fileName}`
    }
  }
  return (
    <img
      className="card-img-top"
      src={src}
      alt=""
    />
  )
}
*/



// WEBPACK FOOTER //
// ./src/contents/Post.js